import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c3952f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-nowrap" }
const _hoisted_2 = { class: "w-2/3 mr-50" }
const _hoisted_3 = {
  key: 1,
  class: "temp-height"
}
const _hoisted_4 = { class: "w-1/3 ml-50" }

import { PropType, ref, Ref } from 'vue';
import {
    StoreContextCheckoutTileModel,
} from '@/types/StoreContextContentServerContract';
import BlockMaxWidthHandler from '@/shared/content/blocks/helpers/BlockMaxWidthHandler.vue';
import CheckoutOrderSummary from '@/storecontext/checkout/ui/CheckoutOrderSummary.vue';
import CheckoutSteps from '@/storecontext/checkout/ui/CheckoutSteps.vue';
import { useCheckout } from '@/storecontext/checkout/useCheckout';


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreContextCheckoutTile',
  props: {
    content: {
        type: Object as PropType<StoreContextCheckoutTileModel>,
        required: true,
    },
},
  setup(__props) {

const { init } = useCheckout();
const initialized: Ref<boolean> = ref(false);

const initialize = async(): Promise<void> => {
    await init();
    initialized.value = true;
};

initialize();




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BlockMaxWidthHandler, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_Transition, {
            name: "o-anim-fade-500",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (initialized.value)
                ? (_openBlock(), _createBlock(CheckoutSteps, {
                    key: 0,
                    class: "mx-auto max-w-750"
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_3))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(CheckoutOrderSummary)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})